import { render } from "./edit-job.vue?vue&type=template&id=7b82a505&ts=true"
import script from "./edit-job.vue?vue&type=script&lang=ts"
export * from "./edit-job.vue?vue&type=script&lang=ts"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__